// Esta llamada es a una API de un controlador de Cifra, no de ninguna api pública
import axios from 'axios';

export default {
  get(options) {
    return axios.get('/alumnos/json', options);
  },
  indicadores(idAlumno, options) {
    // http://localhost:3000/api_publica/v1/alumnos/indicadores?evaluacion_id=9867&asignatura_id=55818&alumno_id[]=43230&alumno_id[]=80944
    const opts = options || {};
    const defaultParams = {
      alumno_id: idAlumno,
    };
    opts.params = Object.assign(defaultParams, opts.params);
    return axios.get('/api_publica/v1/alumnos/indicadores', opts);
  },
};
